import en, { TranslationMessages } from './en';
import flattenMessages from '@liveauctioneers/caterwaul-components/lib/utils/flattenMessages';

/* eslint-disable sort-keys/sort-keys-fix, max-len */
const ko: TranslationMessages = {
    // bidding console
    bidding_console: {
        console: {
            button: {
                login: '응찰자로 로그인하기',
                signup: '응찰자로 가입하기',
                register_long: '응찰등록하기',
                pending: '응찰등록 승인 대기 중',
                declined: '응찰등록 거부됨',
                closed: 'Lot이 마무리되었습니다',
                sent: '응찰가가 전송되었습니다',
                outbid: '경쟁 응찰자가 상회 응찰 제시. 응찰하기 {amount}',
                bid: '응찰하기 {amount}',
                winning: '최고가를 제시한 응찰자입니다',
                // needed
                addPaymentMethod: 'Add Payment to Place Bid',
                approved_limited: "You're approved to bid up to {limit} and have {balance} remaining.",
                backToLiveItem: 'Back To Live Item',
                bidding_locked: 'Bidding Locked',
                bidding_unlocked: 'Bidding Unlocked',
                hide_settings: 'Hide Settings',
                limit_exceeded: 'This item would exceed your bid limit of {limit}',
                show_settings: 'Show Settings',
                suspended: 'Account Suspended',
                waiting: 'Still waiting on approval?',
            },
            // needed
            currentLiveItem: {
                auctioneerInfo: {
                    buttons: {
                        askAQuestion: 'Ask a Question',
                        follow: 'Follow',
                        following: 'Following',
                        followingAuctioneer: 'Following Auctioneer',
                        followAuctioneer: 'Follow Auctioneer',
                    },
                },
                buyersPremium: {
                    middleLowCutOff: '{middle}% above',
                    middleCutOff: '{middle}% up to',
                    highCutOff: '{high}% above',
                    lowCutOff: '{low}% up to',
                    lowPercentage: '{low}%',
                },
                curator: {
                    curatedBy: 'Auction Curated By',
                },
                headers: {
                    buyersPremium: "Buyer's Premium",
                    condition: 'Condition',
                    description: 'Description',
                    dimensions: 'Dimensions',
                    itemDetails: 'Item Details',
                    weight: 'Weight',
                },
            },
            conversions: {
                lot_number: 'LOT {lotNumber}',
            },
            description: {
                estimate_range: '추정가 {low} - {high}',
                images_label: '{currentImageNumber} / {totalImages}',
                // needed
                single_estimate: 'Est. {number}',
                currentBid: 'Current Bid: {amount}',
                convertedBid: 'Conversion: {amount}',
            },
            // needed
            lotTracker: {
                bid: 'Bid',
                bids: 'Bids',
                liveNow: 'Live Now',
                soldFor: 'Sold for',
                passed: 'Passed',
            },
            messages: {
                ask_price_changed_to: 'Ask Price Changed: {amount}{converted}',
                competing_bid_amount: '{amount}{converted}: 현장 응찰',
                competing_bidder_outbid_by_liveauctioneers_absentee:
                    '{paddleNumber}번 응찰자가 현장 응찰자보다 높은 부재자 응찰가를 제시했습니다',
                last_bid_retracted: '마지막 응찰가 {amount}{converted} 철회되었습니다',
                liveauctioneers_bid_amount: '{amount}{converted}: LiveAuctioneers {paddleNumber}번 응찰자',
                liveauctioneers_bid_amount_absentee:
                    '{amount}{converted}: LiveAuctioneers {paddleNumber}번 응찰자의 부재자 응찰',
                lot_number_passed: 'Lot {lotNumber} 통과합니다',
                lot_number_reopened: 'Lot {lotNumber} 다시 오픈합니다',
                lot_number_skipped: 'Lot {lotNumber} 넘어갑니다',
                lot_number_unsold: 'Lot {lotNumber} 유찰되었습니다',
                lot_opened_asking: 'Lot {lotNumber} {amount}{converted} 부터 시작합니다',
                lot_sold_competing_bidder: 'Lot {lotNumber} 현장 응찰자에게 {amount}{converted}에 낙찰되었습니다',
                lot_sold_liveauctioneers_bidder:
                    'Lot {lotNumber} 응찰자 {paddleNumber}번에게 {amount}{converted}에 낙찰되었습니다',
                my_bid_amount: '{amount}{converted}: 고객님 응찰하셨습니다',
                my_bid_amount_absentee: '{amount}{converted}: 고객님 부재자 응찰하셨습니다',
                my_bid_retracted: '고객님의 응찰가 {amount}{converted} 철회되었습니다',
                registration_approved: '응찰등록이 승인되었습니다',
                reserve_not_met: '내정가 미만입니다',
                you_been_outbid_by_liveauctioneers_absentee:
                    '{paddleNumber}번 응찰자가 고객님보다 높은 부재자 응찰가를 제시했습니다',
                you_ve_won_lot: 'Lot {lotNumber} 낙찰받으셨습니다. 축하드립니다',
                // needed
                bid_limit_exceeded: 'Your bid limit exceeded',
                limited_approval: 'Approved to bid up to: {limit}',
                paused: 'Auction Paused',
            },
            // needed
            settingsMenu: {
                headerText: 'Settings',
                language: 'Language',
                currency: 'Currency',
            },
            missives: {
                fair_warning_lot_about_to_close: '이번 Lot 곧 마무리하겠습니다',
                going_once_going_twice: '한번... 두번...',
                third_and_final_warning: '세번... 마무리합니다',
            },
            status: {
                remaining: '{total} Lot중에 {remaining}개 남았습니다',
                // needed
                nextBid: {
                    text: 'My Next Bid',
                    value: '{total} Away',
                },
                nextFavorite: {
                    text: 'My Next Favorite',
                    value: '{total} Away',
                },
            },
            thumbnail_scroller: {
                next: '다음 Lot 미리보기',
            },
            // needed
            lockText: {
                locked: 'Unlock to Bid',
                unlocked: 'Bidding Unlocked',
            },
            mobileHeader: {
                title: '{lotNumber}: {title}',
            },
            mobileFooter: {
                itemSaves: '{savedCount}',
            },
        },
        // needed
        explainer_modal: {
            title: 'Welcome to the Auction',
            subtext: 'Good luck! Please review some auction details.',
            fee_disclaimer:
                'The price of your bid does not include potential fees, such as a buyer’s premium, taxes, shipping, or processing fee',
            autopay_disclaimer: 'You will be charged the full price shortly after the conclusion of the auction',
            shipping_disclaimer: 'Shipping details can be found in this auction’s Shipping, Payment & Auction Policies',
            button: 'Got it',
        },
        wait: {
            title: 'Stay tuned. Auction will begin shortly',
            status_message: "{name} is delighted you're here!",
            login_button_text: 'Log In',
            register_button_text: 'Register for Auction',
            image_slider_text: 'Popular Lots in This Auction',
            hidden_text: 'View the Catalog',
            card: {
                title: 'Lot {lotNumber}: {title}',
                bid: 'Bid',
                bids: 'Bids',
            },
        },
        done: {
            title: '{title} has ended',
            status_message: 'Follow {name} to hear about their next auction.',
            live_catalogs_title: 'View Other Live Auctions',
            upcoming_catalogs_title: 'Upcoming Auctions',
        },
    },
};

export default { ...en, ...flattenMessages(ko) };
